/* JACOB BEAUTY THEME — interakce */
(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- cursor glow ---------- */
  const glow = document.querySelector('.cursor-glow');
  let mx = innerWidth / 2, my = innerHeight / 2, gx = mx, gy = my;
  window.addEventListener('pointermove', (e) => {
    mx = e.clientX; my = e.clientY;
    document.body.classList.add('has-mouse');
  }, { passive: true });

  if (glow && !reduceMotion) {
    (function glowLoop() {
      gx += (mx - gx) * 0.12;
      gy += (my - gy) * 0.12;
      glow.style.transform = `translate(${gx - 170}px, ${gy - 170}px)`;
      requestAnimationFrame(glowLoop);
    })();
  }

  /* ---------- tekutý hero ---------- */
  const canvas = document.getElementById('liquid');
  if (canvas) {
    const ctx = canvas.getContext('2d');
    let W, H, blobs = [];
    const PALETTE = [[46,125,99],[228,169,172],[201,162,75],[143,166,176]];

    function sizeCanvas() {
      W = canvas.width = canvas.offsetWidth * devicePixelRatio;
      H = canvas.height = canvas.offsetHeight * devicePixelRatio;
    }
    function makeBlobs() {
      blobs = [];
      const n = innerWidth < 720 ? 6 : 9;
      for (let i = 0; i < n; i++) {
        blobs.push({
          x: Math.random() * W, y: Math.random() * H,
          r: (Math.random() * 0.13 + 0.10) * Math.max(W, H),
          vx: (Math.random() - 0.5) * 0.35 * devicePixelRatio,
          vy: (Math.random() - 0.5) * 0.35 * devicePixelRatio,
          c: PALETTE[i % PALETTE.length],
          a: 0.16 + Math.random() * 0.10,
          phase: Math.random() * Math.PI * 2,
        });
      }
    }
    function paint(t, animate) {
      ctx.clearRect(0, 0, W, H);
      const px = mx * devicePixelRatio, py = my * devicePixelRatio;
      for (const b of blobs) {
        let r = b.r;
        if (animate) {
          b.x += b.vx; b.y += b.vy;
          r = b.r * (1 + Math.sin(t / 1600 + b.phase) * 0.06);
          const dx = px - b.x, dy = py - b.y;
          const dist = Math.hypot(dx, dy) || 1;
          if (dist < W * 0.4) {
            b.x += (dx / dist) * 0.6 * devicePixelRatio;
            b.y += (dy / dist) * 0.6 * devicePixelRatio;
          }
          if (b.x < -b.r) b.x = W + b.r; if (b.x > W + b.r) b.x = -b.r;
          if (b.y < -b.r) b.y = H + b.r; if (b.y > H + b.r) b.y = -b.r;
        }
        const g = ctx.createRadialGradient(b.x, b.y, 0, b.x, b.y, r);
        g.addColorStop(0, `rgba(${b.c[0]},${b.c[1]},${b.c[2]},${b.a})`);
        g.addColorStop(1, `rgba(${b.c[0]},${b.c[1]},${b.c[2]},0)`);
        ctx.fillStyle = g;
        ctx.beginPath(); ctx.arc(b.x, b.y, r, 0, Math.PI * 2); ctx.fill();
      }
      if (animate) requestAnimationFrame((tt) => paint(tt, true));
    }
    sizeCanvas(); makeBlobs();
    window.addEventListener('resize', () => { sizeCanvas(); makeBlobs(); if (reduceMotion) paint(0, false); });
    if (reduceMotion) paint(0, false); else requestAnimationFrame((t) => paint(t, true));
  }

  /* ---------- magnetická tlačítka ---------- */
  if (!reduceMotion) {
    document.querySelectorAll('.btn--magnetic').forEach((btn) => {
      btn.addEventListener('pointermove', (e) => {
        const r = btn.getBoundingClientRect();
        btn.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * 0.18}px, ${(e.clientY - r.top - r.height / 2) * 0.18}px)`;
      });
      btn.addEventListener('pointerleave', () => { btn.style.transform = ''; });
    });
  }

  /* ---------- 3D náklon karet ---------- */
  if (!reduceMotion) {
    document.querySelectorAll('.tilt').forEach((card) => {
      card.addEventListener('pointermove', (e) => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = `perspective(800px) rotateX(${-y * 7}deg) rotateY(${x * 7}deg)`;
      });
      card.addEventListener('pointerleave', () => { card.style.transform = ''; });
    });
  }

  /* ---------- rituální koule ---------- */
  const orb = document.getElementById('ritualOrb');
  if (orb) {
    const orbNum = document.getElementById('ritualNum');
    const steps = document.querySelectorAll('.ritual__step');
    function activateStep(step) {
      steps.forEach((s) => s.classList.remove('is-active'));
      step.classList.add('is-active');
      orbNum.textContent = step.dataset.step;
      orb.className = 'ritual__orb';
      if (step.dataset.hue !== 'jade') orb.classList.add('hue-' + step.dataset.hue);
    }
    steps.forEach((s) => {
      s.addEventListener('pointerenter', () => activateStep(s));
      s.addEventListener('click', () => activateStep(s));
    });
    let autoIdx = 0, userTouched = false;
    if (!reduceMotion && steps.length > 1) {
      const timer = setInterval(() => {
        if (userTouched) return clearInterval(timer);
        autoIdx = (autoIdx + 1) % steps.length;
        activateStep(steps[autoIdx]);
      }, 3200);
      document.getElementById('ritualSteps').addEventListener('pointerenter', () => { userTouched = true; });
    }
  }

  /* ---------- kvíz ---------- */
  const quizBox = document.getElementById('quizBox');
  if (quizBox) {
    const quizSteps = quizBox.querySelectorAll('.quiz__step');
    const quizBar = document.getElementById('quizBar');
    const d = quizBox.dataset;
    const results = {
      guasha: { title: d.resultGuashaTitle, text: d.resultGuashaText, url: d.resultGuashaUrl },
      roller: { title: d.resultRollerTitle, text: d.resultRollerText, url: d.resultRollerUrl },
      globes: { title: d.resultGlobesTitle, text: d.resultGlobesText, url: d.resultGlobesUrl },
    };
    let scores = { guasha: 0, roller: 0, globes: 0 };
    let qIndex = 0;

    function showQuizStep(i) {
      quizSteps.forEach((s) => s.classList.remove('is-visible'));
      const target = typeof i === 'number'
        ? quizBox.querySelector(`[data-q="${i}"]`)
        : quizBox.querySelector('[data-q="result"]');
      target.classList.add('is-visible');
      quizBar.style.width = (typeof i === 'number' ? (i / 3) * 100 : 100) + '%';
    }

    quizBox.querySelectorAll('.quiz__opts button').forEach((btn) => {
      btn.addEventListener('click', () => {
        scores[btn.dataset.score]++;
        qIndex++;
        if (qIndex < 3) {
          showQuizStep(qIndex);
        } else {
          const winner = Object.entries(scores).sort((a, b) => b[1] - a[1])[0][0];
          const res = results[winner];
          document.getElementById('quizResultTitle').textContent = res.title || '';
          document.getElementById('quizResultText').textContent = res.text || '';
          const cta = document.getElementById('quizResultCta');
          if (res.url) { cta.href = res.url; cta.style.display = ''; } else { cta.style.display = 'none'; }
          showQuizStep('result');
        }
      });
    });

    document.getElementById('quizRestart').addEventListener('click', () => {
      scores = { guasha: 0, roller: 0, globes: 0 };
      qIndex = 0;
      showQuizStep(0);
    });
  }

  /* ---------- produkt: varianty a náhledy ---------- */
  const variantSelect = document.getElementById('VariantSelect');
  if (variantSelect) {
    variantSelect.addEventListener('change', () => {
      const opt = variantSelect.selectedOptions[0];
      const priceEl = document.getElementById('ProductPrice');
      if (priceEl && opt.dataset.price) {
        priceEl.innerHTML = opt.dataset.price + (opt.dataset.compare ? ' <s>' + opt.dataset.compare + '</s>' : '');
      }
    });
  }
  const mainImg = document.getElementById('ProductMainImage');
  if (mainImg) {
    document.querySelectorAll('.product-page__thumb').forEach((t) => {
      t.addEventListener('click', () => { mainImg.src = t.dataset.src; });
    });
  }

  /* ---------- scroll reveals ---------- */
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.15 });
  document.querySelectorAll('.reveal').forEach((el) => io.observe(el));

  /* ---------- nav ---------- */
  const nav = document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('is-scrolled', scrollY > 40);
    }, { passive: true });
  }
})();
